import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  children: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'md', loading = false, children, className, disabled, ...rest },
  ref
) {
  const classes = [
    'sarnia-btn',
    `sarnia-btn--${variant}`,
    `sarnia-btn--${size}`,
    className ?? ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button ref={ref} className={classes} disabled={disabled || loading} {...rest}>
      {loading ? <span className="sarnia-spinner sarnia-spinner--sm" /> : null}
      {children}
    </button>
  );
});
